(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["judgeme-product-review-widget"] && !Shopify.designMode) return;
  try {
    (() => {
    const ensureFirst1000CheckoutLinks = () => {
      document.querySelectorAll('[data-pelvic-checkout-link], [data-pelvic-checkout-select] option[data-checkout-url]').forEach((element) => {
        const attr = element.matches('option') ? 'data-checkout-url' : 'href';
        const value = element.getAttribute(attr);
        if (!value || !value.includes('/cart/46302170')) return;
        const url = new URL(value, window.location.origin);
        const cartPath = `${url.pathname}?${url.searchParams.toString()}`;
        element.setAttribute(attr, `${url.origin}/discount/FIRST1000?redirect=${encodeURIComponent(cartPath)}`);
      });
    };

    ensureFirst1000CheckoutLinks();
    window.setTimeout(ensureFirst1000CheckoutLinks, 1200);

    const reviewRoots = document.querySelectorAll('.mofflue-judgeme-lp #judgeme_product_reviews[data-product-url]');
    reviewRoots.forEach((root) => {
      const productUrl = root.getAttribute('data-product-url');
      if (!productUrl) return;

      let productReviewBlockPromise;
      const getProductReviewBlock = () => {
        if (!productReviewBlockPromise) {
          productReviewBlockPromise = fetch(`${productUrl}?_ab=0&_fd=0&_sc=1`, { credentials: 'same-origin' })
            .then((response) => {
              if (!response.ok) return null;
              return response.text();
            })
            .then((html) => {
              if (!html) return null;
              const doc = new DOMParser().parseFromString(html, 'text/html');
              return doc.querySelector('#judgeme_product_reviews');
            })
            .catch(() => null);
        }
        return productReviewBlockPromise;
      };

      const formatReviewDate = (rawDate) => {
        if (!rawDate) return '';
        const normalizedDate = rawDate.replace(' UTC', 'Z');
        const date = new Date(normalizedDate);
        if (Number.isNaN(date.getTime())) return rawDate;

        return new Intl.DateTimeFormat('ja-JP', {
          year: 'numeric',
          month: 'numeric',
          day: 'numeric',
          timeZone: 'Asia/Tokyo',
        }).format(date);
      };

      const applyProductReviewBlock = () => {
        if (root.querySelector('.jdgm-rev')) return;
        getProductReviewBlock().then((productRoot) => {
          if (!productRoot) return;
          if (root.querySelector('.jdgm-rev')) return;
          const clone = productRoot.cloneNode(true);
          clone.querySelectorAll('.jdgm-temp-hiding-style').forEach((style) => style.remove());
          clone.querySelectorAll('.jdgm-legacy-widget-content').forEach((content) => {
            content.style.display = 'block';
          });
          clone.querySelectorAll('.jdgm-spinner').forEach((spinner) => {
            spinner.classList.remove('jdgm-spinner');
          });
          clone.querySelectorAll('.jdgm-rev__timestamp').forEach((timestamp) => {
            const displayDate = formatReviewDate(timestamp.getAttribute('data-content') || timestamp.textContent.trim());
            if (!displayDate) return;
            timestamp.textContent = displayDate;
            timestamp.setAttribute('aria-label', `投稿日 ${displayDate}`);
          });
          clone.querySelectorAll('.jdgm--loading').forEach((loading) => {
            loading.classList.remove('jdgm--loading');
          });
          clone.querySelectorAll('.jdgm-rev-widg__paginate-spinner-wrapper').forEach((spinnerWrapper) => {
            spinnerWrapper.remove();
          });
          clone.querySelectorAll('img[data-src]').forEach((img) => {
            if (!img.getAttribute('src')) img.setAttribute('src', img.getAttribute('data-src'));
            img.style.visibility = 'visible';
          });
          clone.querySelectorAll('source[data-srcset]').forEach((source) => {
            if (!source.getAttribute('srcset')) source.setAttribute('srcset', source.getAttribute('data-srcset'));
          });
          const title = clone.querySelector('.jdgm-rev-widg__title');
          if (title) title.textContent = 'カスタマーレビュー';
          const widget = clone.querySelector('.jdgm-rev-widg');
          const count = widget ? widget.getAttribute('data-number-of-reviews') : clone.getAttribute('data-number-of-reviews');
          const summary = clone.querySelector('.jdgm-rev-widg__summary-text');
          if (summary && count) summary.textContent = `${count}件のレビュー`;
          const writeLink = clone.querySelector('.jdgm-write-rev-link');
          if (writeLink) writeLink.textContent = 'レビューを書く';
          root.innerHTML = clone.innerHTML;
        });
      };

      [0, 1200, 3000, 6000].forEach((delay) => {
        window.setTimeout(applyProductReviewBlock, delay);
      });

      const observer = new MutationObserver(() => {
        if (!root.querySelector('.jdgm-rev') && !root.querySelector('[data-widget-container="review-widget"]')) {
          applyProductReviewBlock();
        }
      });
      observer.observe(root, { childList: true, subtree: true });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
